import { FC, JSX } from 'react'
import { StatusTag, StatusTagType } from './StatusTag'

export const CompanyStatuses: FC & StatusTagType = (): JSX.Element => <></>

CompanyStatuses.StatusTag = StatusTag
